import {
  liveEventDiagnosticContext,
  safeLiveEventError,
} from '@/lib/live-events/diagnostic-context';
import { logger } from './logger';

export function containDiagnosticFailure(
  observe: () => void,
  context: { stage: string; network: string; attemptId?: string; correlationId?: string },
): void {
  try {
    observe();
  } catch (error: unknown) {
    try {
      logger.error('live_events.diagnostic_failed', {
        ...liveEventDiagnosticContext(),
        ...safeLiveEventError(error),
        ...context,
      });
    } catch {
      // Both sinks failed. A recursive fallback cannot restore delivery and
      // must not alter cache results or handled pagination promises.
      return;
    }
  }
}
